export const STEP_TRANSITION_VARIANTS = [
  "fade",
  "fade-up",
  "fade-down",
  "fade-left",
  "fade-right",
  "scale",
] as const;

export type StepTransitionVariant = (typeof STEP_TRANSITION_VARIANTS)[number];

export const DEFAULT_STEP_TRANSITION_DURATION_MS = 250;
export const DEFAULT_STEP_TRANSITION_DELAY_BEFORE_EXIT_MS = 250;
export const MAX_STEP_TRANSITION_DURATION_MS = 10000;
export const DEFAULT_STEP_TRANSITION_VARIANT: StepTransitionVariant = "fade-up";

export const STEP_TRANSITION_VARIANT_OPTIONS = [
  { title: "Fade", value: "fade" },
  { title: "Fade + slide up", value: "fade-up" },
  { title: "Fade + slide down", value: "fade-down" },
  { title: "Fade + slide from left", value: "fade-left" },
  { title: "Fade + slide from right", value: "fade-right" },
  { title: "Scale / zoom in", value: "scale" },
] as const satisfies ReadonlyArray<{
  title: string;
  value: StepTransitionVariant;
}>;

export function isStepTransitionVariant(
  value: unknown,
): value is StepTransitionVariant {
  return STEP_TRANSITION_VARIANTS.includes(value as StepTransitionVariant);
}
